// extracted by mini-css-extract-plugin
var _1 = "FeatureIntegrationPrompt-module__animateUploadProgressBarWidth--yH0Fn";
var _2 = "FeatureIntegrationPrompt-module__animatedBackground--S3iSO";
var _3 = "FeatureIntegrationPrompt-module__authDescription--R_DnW";
var _4 = "FeatureIntegrationPrompt-module__authPrompt--HDi8y";
var _5 = "FeatureIntegrationPrompt-module__buttonContainer--CsTJx";
var _6 = "FeatureIntegrationPrompt-module__logoContainer--YimbF";
var _7 = "FeatureIntegrationPrompt-module__title--QdQ43";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "authDescription", _4 as "authPrompt", _5 as "buttonContainer", _6 as "logoContainer", _7 as "title" }
